import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { Text } from '@components/primitives/Text'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'

export function ShareYourStoryPatientQuoteCard({
  condition,
  externalId,
  quote,
}: {
  condition?: string
  externalId?: string
  quote: string
}) {
  return (
    <div className='h-auto w-full rounded-lg bg-primary600 p-4'>
      <div className='flex flex-col gap-4'>
        <Text
          className={'line-clamp-6 leading-normal text-white'}
          styleName='p-small'
          value={`"${quote}"`}
        />

        <div className='flex flex-row items-center gap-2'>
          <div className='flex size-10 flex-row items-center justify-center rounded-full bg-white text-primary600'>
            {externalId ? (
              <CloudflareImage
                alt={`My Profile`}
                className='rounded-full'
                height={36}
                imageId={externalId}
                width={36}
              />
            ) : (
              <Icon className='text-primary600' icon={faUser} size='lg' />
            )}
          </div>
          <div className='flex flex-col'>
            <Text
              className={'leading-tight text-white'}
              element='p'
              styleName='p-small-strong'
              value='Patient Champion'
            />
            {condition && (
              <Text
                className={'leading-tight text-primary200'}
                element='p'
                styleName='p-small'
                value={condition}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
